import { IConfiguredAddon, IEndpoint } from 'src/types/aggregator.types';

/**
 * `export_menu` is what the publish handler resolves today. `export_timetable` and
 * `export_timetable_bulk` are the timetable payload (AZ-8476): a connector offering either has
 * declared it understands the document, and which of the two says only whether it wants one call
 * per venue or one call for the whole brand. Both belong in the picker.
 */
export const TIMETABLE_ENDPOINT_CODES = ['export_menu', 'export_timetable', 'export_timetable_bulk'];

// `addon_endpoint_types.code` is nullable; derive it from the name the way marketplace V5 backfilled it.
export const codeOf = ({ endpointCode, endpointName }: IEndpoint): string =>
  endpointCode ?? endpointName.toLowerCase().replaceAll(' ', '_');

/** Mirrors the handler's ENDPOINT_NOT_FOUND, ENDPOINT_DISABLED and UrlNotConfigured checks. */
export const canReceiveTimetable = ({ endpoints }: IConfiguredAddon): boolean =>
  endpoints.some(
    (endpoint) =>
      TIMETABLE_ENDPOINT_CODES.includes(codeOf(endpoint)) && endpoint.isEnabled && Boolean(endpoint.endpointUrl),
  );
